import { Link } from 'react-router-dom'

const LINKS = [
  { label: 'Contato', href: '/contato' },
  { label: 'Privacidade', href: '/privacidade' },
  { label: 'Cookies', href: '/cookies' },
  { label: 'Anúncios', href: '/anuncios' },
]

export function Footer() {
  return (
    <footer className="mt-auto border-t border-line/70 bg-canvas py-8">
      <nav aria-label="Links institucionais">
        <ul className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 px-4 text-sm text-ink-soft">
          {LINKS.map((link, index) => (
            <li key={link.href} className="flex items-center gap-3">
              <Link to={link.href} className="transition-colors hover:text-ink hover:underline">
                {link.label}
              </Link>
              {index < LINKS.length - 1 && (
                <span aria-hidden="true" className="text-line-strong">
                  |
                </span>
              )}
            </li>
          ))}
        </ul>
      </nav>

      <p className="mt-4 text-center text-sm text-ink-soft">
        Mercado Prêmio © {new Date().getFullYear()}
      </p>
    </footer>
  )
}
